import BaseError from "./BaseError";

export default class ForbiddenError extends BaseError {
  constructor(message: string, info?: any, cause?: Error) {
    super({
      statusCode: 403,
      message,
      info: info || null,
      cause,
    });
    this.name = "ForbiddenError";
  }
}
